import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function GrowthBanner() {
  const [item, setItem] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api.get("/api/announcements/active");
        const firstBanner = (r.data.items || []).find(x => x.type === "banner");
        if (!mounted) return;
        if (firstBanner) {
          const dismissed = localStorage.getItem(`dismiss_banner_${firstBanner.id}`);
          if (!dismissed) setItem(firstBanner);
        }
      } catch {}
    })();
    return () => { mounted = false; };
  }, []);

  if (!item) return null;

  return (
    <div style={wrap} data-testid="growth-banner">
      <div style={{ fontWeight: 900 }}>{item.title}</div>
      <div style={{ opacity: 0.9 }}>{item.body}</div>
      <button
        style={x}
        onClick={() => {
          localStorage.setItem(`dismiss_banner_${item.id}`, "1");
          setItem(null);
        }}
        aria-label="Dismiss"
        data-testid="growth-banner-dismiss"
      >
        ✕
      </button>
    </div>
  );
}

const wrap = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "10px 12px",
  background: "linear-gradient(90deg, rgba(108,74,242,0.22), rgba(0,0,0,0.08))",
  borderBottom: "1px solid rgba(0,0,0,0.08)",
};

const x = {
  marginLeft: "auto",
  border: "1px solid rgba(0,0,0,0.12)",
  background: "#fff",
  borderRadius: 10,
  width: 34,
  height: 34,
  cursor: "pointer",
  fontWeight: 900,
};
